<template>
  <div>
    <post-search v-if="userId && ready"></post-search>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import PostSearch from './postSearch/PostSearch.vue'

  export default {
    components: {
      PostSearch,
    },
    data() {
      return {
        ready: false,
      }
    },
    computed: {
      ...mapState({
        digitalEnabled: state => state.auth.user.prison.purple_post_digital_enabled,
        printOnSite: state => state.auth.user.prison.purple_post_print_on_site,
        filters: state => state.postCard.filters,
        userId: state => state.auth.user.user_id,
      }),
    },
    mounted() {
      if (!this.ready) { // on first load set initial filters
        this.setFiltersFromPrisonPostType();
      }
      this.ready = true;
    },
    methods: {
      setFiltersFromPrisonPostType() {
        // Physical post, print on site, ready for print
        this.updateSearchPageFilters({
          status: 'Approved',
          sentForPrinting: false,
          delivered: false,
          dispatched: false,
          printOnSite: true,
        });
      },
      updateSearchPageFilters(filters, digitalPost = false) {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const filtersKey in filters) {
          this.updateFilter(filtersKey, filters[filtersKey]);
        }
        this.updateFilter('postType', digitalPost ? 'Digital' : 'Physical');

        this.$store.commit('postCard/SET_DEFAULT_FILTERS', { ...this.filters }); // set new default filters
      },
      updateFilter(filterName, e) {
        this.$store.commit('postCard/SET_FILTER_ITEM', { name: filterName, value: e });
      },
    },
  }
</script>

<style>

</style>
